import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { CONSTANTES } from '../../shared/constanst/url-scrolls-header';

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {

  params: any = {
    responseType: 'text'
  };
  currentUser: any = null;

  constructor(private http: HttpClient) {} 

  login(request: any): Observable<any> {
    return this.http.post(`${CONSTANTES.URL_PRODUCCION}/login`, request, this.params)
      .pipe(
        tap(response => {
          // Guardar en localStorage

          let respuesta: any = JSON.parse(response);
 
          localStorage.setItem("currentUser", respuesta);
          localStorage.setItem('token', respuesta.token);
          this.currentUser = respuesta;
        })
      );
  }  

  isAuthenticated(): boolean {
    if (!this.currentUser) {
      this.currentUser = localStorage.getItem("currentUser");
    }
    return !!this.currentUser;
  }  

  hasRole(role: string): boolean {
    const user = this.currentUser ? this.currentUser : JSON.parse(localStorage.getItem("currentUser") || "{}");
    return user?.roles?.includes(role);
  }  

  verificarAutenticacion(): Observable<any> {
    return this.http.get(`${CONSTANTES.URL_PRODUCCION}/verificar-auth`, this.params).pipe(
      tap(response => {
        if (response) {
          localStorage.setItem("currentUser", JSON.stringify(response));
          this.currentUser = response;
        }
      })
    );
  }  
}
